<template>
  <section class="section container pt-0">
    <files-datatable />
  </section>
</template>

<script>
import FilesDatatable from "./files_datatable/Index.vue";

export default {
  name: "DriveFiles",
  components: { FilesDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
